import { render, staticRenderFns } from "./table-footer-goal-setting.component.vue?vue&type=template&id=18d29a70&scoped=true"
import script from "./table-footer-goal-setting.component.vue?vue&type=script&lang=ts"
export * from "./table-footer-goal-setting.component.vue?vue&type=script&lang=ts"
import style0 from "./table-footer-goal-setting.component.vue?vue&type=style&index=0&id=18d29a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d29a70",
  null
  
)

export default component.exports